module.exports = __webpack_public_path__ + "static_pc/img/af2.23867f8b.png";